import { Component, inject } from '@angular/core';
import { LoaderService } from 'src/app/core/services/loader';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
})
export class LoaderComponent {
  loaderService = inject(LoaderService);

  showLoader$ = this.loaderService.showLoader$;
  loaderTexts$ = this.loaderService.loaderTexts$;
}
